import { createAuthClient } from "better-auth/react";
import {
  phoneNumberClient,
  organizationClient,
  adminClient,
} from "better-auth/client/plugins";

export const authClient = createAuthClient({
  basePath: "/api/v1/authorization",
  plugins: [phoneNumberClient(), adminClient(), organizationClient()],
  fetchOptions: {
    onSuccess: (ctx) => {
      const authToken = ctx.response.headers.get("set-auth-token");

      if (authToken) localStorage.setItem("access_token", authToken);
    },
  },
});
